import { DeepPartial, FormTruckComposition } from '@/types';

export type VehicleSearchState = {
  data: DeepPartial<FormTruckComposition>[];
};

export const vehicleSearchActions = ['vehicle_search_update_data'] as const;

export type VehicleSearchStateAction = (typeof vehicleSearchActions)[number];
